export const styles = {
  dialogPaper: {
    backgroundColor: "background.paper",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    borderRadius: 1,
    width: "50%",
    minWidth: "315px",
    p: 1,
  },
  dialogContent: {
    textAlign: "center",
    padding: "20px 24px",
  },
  dialogTitle: {
    color: "text.secondary",
    fontWeight: 400,
    mb: 1,
  },
  dialogActions: {
    justifyContent: "center",
    gap: 2,
    paddingBottom: "16px",
  },
  errorTitle: {
    color: "secondary.main",
    textTransform: "uppercase",
  },
};
